// mds-dojo — dojo/_base/connect: the legacy connect/subscribe API, shimmed onto
// on/aspect/topic exactly the way dojo 1.x implemented it: DOM node + event name
// → on(); object method → aspect.after(..., true); publish/subscribe → topic.

import on from '../on';
import aspect from '../aspect';
import topic from '../topic';
import lang from './lang';

type Handle = { remove: () => void };

function normalizeEventName(name: string): string {
  return name.slice(0, 2) === 'on' ? name.slice(2) : name;
}

export function connect(obj: any, event: string, context: any, method?: any, dontFix?: boolean): Handle {
  // dojo allowed (event, context, method) with obj omitted → global/window
  if (typeof obj === 'string' && (typeof event === 'object' || typeof event === 'function')) {
    // connect(event, context, method) form
    return connect(window, obj as any, event as any, context);
  }
  const cb = method == null ? context : lang.hitch(context, method);
  const isNode = obj && (obj.nodeType || obj === window || obj === document);
  if (isNode) {
    return on(obj, normalizeEventName(event), cb);
  }
  return aspect.after(obj || window, event, cb, true);
}

export function disconnect(handle: Handle | null | undefined): void {
  if (handle && typeof handle.remove === 'function') { handle.remove(); }
}

export function subscribe(topicName: string, context: any, method?: any): Handle {
  const cb = method == null ? context : lang.hitch(context, method);
  return topic.subscribe(topicName, cb);
}

export function unsubscribe(handle: Handle | null | undefined): void {
  disconnect(handle);
}

export function publish(topicName: string, args?: any[]): void {
  // legacy connect.publish passes an ARRAY that is spread to listeners
  topic.publish(topicName, ...(args || []));
}

const connectModule = { connect, disconnect, subscribe, unsubscribe, publish };
export default connectModule;
